import {Timer, now} from "./timer";

export default function(callback, delay, time) {
  var t = new Timer, total = delay;
  if (delay == null) return t.restart(callback, delay, time), t;
  delay = +delay, time = time == null ? now() : +time;
  t.restart(function tick(elapsed) {
    elapsed += total;
    t.restart(tick, total += delay, time);
    callback(elapsed);
  }, delay, time);
  return t;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-timer/src/interval.js
// module id = 1679
// module chunks = 0